/* owkar-about-banner.js - Scroll and editor interactions for Page Banner */

(function() {
  function initBannerParallax() {
    const banners = document.querySelectorAll('.space-banner-card');
    if (banners.length === 0) return;

    function handleParallax() {
      const viewHeight = window.innerHeight;
      banners.forEach(banner => {
        const bannerImg = banner.querySelector('.space-banner-img');
        if (!bannerImg) return;
        const rect = banner.getBoundingClientRect();
        if (rect.top < viewHeight && rect.bottom > 0) {
          const scrollProgress = (viewHeight - rect.top) / (viewHeight + rect.height);
          const translateY = (scrollProgress - 0.5) * 80;
          bannerImg.style.transform = `translateY(${translateY}px)`;
        }
      });
    }

    // Clean up existing listeners to avoid duplication
    window.removeEventListener('scroll', handleParallax);
    window.removeEventListener('resize', handleParallax);

    // Register listeners
    window.addEventListener('scroll', handleParallax, { passive: true });
    window.addEventListener('resize', handleParallax, { passive: true });
    
    // Initial calculation
    handleParallax();
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBannerParallax);
  } else {
    initBannerParallax();
  }

  // Shopify theme editor integration
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.space-banner-card')) {
      initBannerParallax();
    }
  });
})();
